import React from 'react';
import { Card, Typography } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

interface UploadProjectCardProps {
  isScanning: boolean;
  onUpload: () => void;
}

const UploadProjectCard: React.FC<UploadProjectCardProps> = ({
  isScanning,
  onUpload,
}) => {
  return (
    <Card
      variant="upload"
      aria-disabled={isScanning}
      role="button"
      tabIndex={isScanning ? -1 : 0}
      onClick={isScanning ? undefined : onUpload}
      onKeyDown={(event) => {
        if (!isScanning && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          onUpload();
        }
      }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: isScanning ? 'default' : 'pointer',
        minHeight: 128,
        borderWidth: 1,
        borderRadius: '9px',
        height: '100%',
        boxSizing: 'border-box',
      }}
    >
      <AddIcon
        className="upload-icon"
        sx={{
          fontSize: 24,
          color: 'inherit',
          mb: 0.75,
          transition: 'all 0.25s ease',
        }}
      />
      <Typography
        className="upload-text"
        variant="body2"
        sx={{
          color: 'inherit',
          fontWeight: 600,
          fontSize: '0.8rem',
          transition: 'color 0.25s ease',
        }}
      >
        Upload Project
      </Typography>
    </Card>
  );
};

export default UploadProjectCard;
